import React, { useEffect, useState } from 'react';
import {
	AiFillCopy,
	AiFillDelete,
	AiFillFileAdd,
	AiFillPrinter,
	AiOutlineArrowDown,
	AiOutlineArrowUp,
} from 'react-icons/ai';
import { BiExport, BiImport } from 'react-icons/bi';
import { IoAddOutline, IoDuplicateOutline } from 'react-icons/io5';
import { convertStringToNumber } from '../../Utils';
import TableManager from '../../../components/tableManager/TableManager';
import NotiDialog from '../../components/NotiDialog';
import { useCore } from '../../../../../hooks';

const defaultValues = {
	ton_kho: 0,
	sl_nhap: 0,
	gia_von: 0,
	gia_von_nt: 0,
	tien_nhap: 0,
	tien_nhap_nt: 0,
	pn_gia_tb: true,
	ma_kh: '',
	ma_bp: '',
	ma_phi: '',
	ma_hd: '',
	ma_dt: '',
	ma_nv: '',
	ma_lo: '',
	ma_vt2: '',
	ma_tt1: '',
	ma_tt2: '',
	ma_tt3: '',
	ma_sp: '',
	ma_tt1_sp: '',
	ma_tt2_sp: '',
	ma_tt3_sp: '',
	ma_cum_chi_tiet: '',
	ten_cum_chi_tiet: '',
	ma_cong_doan: '',
	line: 0,
	ma_vt: '',
	ma_dvt: '',
	tk_vt: '',
	han_sd: '',
	ten_tk_vt: '',
	ten_vt: '',
};

function TabDetail({ data, readonly, handleGetDataDetail, view, isFieldNt }) {
	const core = useCore();
	const [open, setOpen] = useState(false);
	const handleClose = () => {
		setOpen(false);
	};
	const handleSubmit = async (values) => {
		try {
			await core.asyncPostList(core.token, 'dmlo', values);
		} catch (error) {
			core.contextAlert(error);
		}
	};

	const DropdownIndicator = () => (
		<button className="btn_select_create" onClick={() => setOpen(true)}>
			<IoAddOutline size={20} />
		</button>
	);
	useEffect(() => {
		if (view || !isFieldNt.checkEdit) {
			for (let i = 0; i < isDataVoucherDetail.length; i++) {
				updateMyData(i, 'tien', convertStringToNumber(isDataVoucherDetail[i].tien_nt) * isFieldNt?.ty_gia);
			}
		} else return;
	}, [isFieldNt]);

	const [isma_vt, setIsma_vt] = useState();
	const [isTen_vt, setIsTen_vt] = useState();
	const handleOnFocusMaVt = (index) => {
		setIsma_vt(isDataVoucherDetail[index].ma_vt);
		setIsTen_vt(isDataVoucherDetail[index].ten_vt);
	};

	const columns = [
		{
			Header: 'Mã hàng',
			accessor: 'ma_vt',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'ten_vt', item.ten_vt);
					updateMyData(index, 'ma_vt', item.ma_vt);
					updateMyData(index, 'tk_vt', item.tk_vt);
					updateMyData(index, 'ma_dvt', item.ma_dvt);
					updateMyData(index, 'ton_kho', item.ton_kho_online_hien_tai);
				},
				valueField: 'ma_vt',
				labelField: 'ten_vt',
				api: 'dmvt',
				q: { status: true },
				// filter: { ma_kh: "", ma_kho: "123" },
				getLabel: (item) => {
					return `${item.ma_vt}`;
				},
			},
		},
		{
			Header: 'Tên mặt hàng',
			accessor: 'ten_vt',
			width: 250,
			minWidth: 200,
			maxWidth: 400,
		},
		{
			Header: 'Đvt',
			accessor: 'ma_dvt',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			type: 'select',
			handleOnFocus: handleOnFocusMaVt,
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'ma_dvt', item.ma_dvt);
				},
				valueField: 'ma_dvt',
				labelField: 'ten_dvt',
				api: 'dmqddvt',
				q: {
					status: true,
					ma_vt: isma_vt,
				},
				getLabel: (item) => {
					return `${item.ma_dvt}`;
				},
			},
		},
		{
			Header: 'TK vật tư',
			accessor: 'tk_vt',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'tk_vt', item.tk);
				},
				valueField: 'tk',
				labelField: 'ten_tk',
				api: 'account',
				q: {
					status: true,
					loai_tk: 1,
				},
				prefix: true,
				getLabel: (item) => {
					return `${item.tk} - ${item.ten_tk}`;
				},
			},
		},
		{
			Header: 'Tồn kho',
			accessor: 'ton_kho',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
		},
		{
			Header: 'Mã lô',
			accessor: 'ma_lo',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			type: 'select',
			handleOnFocus: handleOnFocusMaVt,
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'ma_lo', item.ma_lo);
				},
				valueField: 'ma_lo',
				labelField: 'ten_lo',
				api: 'dmlo',
				q: {
					status: true,
					ma_vt: isma_vt,
				},
				prefix: true,
				getLabel: (item) => {
					return `${item.ma_lo} - ${item.ten_lo}`;
				},
				componentAdd: { DropdownIndicator },
			},
		},
		{
			Header: 'SL nhập',
			accessor: 'sl_nhap',
			width: 100,
			minWidth: 70,
			maxWidth: 400,
			type: 'number',
			Filter: false,
			handleOnChange: (index, value) => {
				updateMyData(
					index,
					'tien_nhap_nt',
					convertStringToNumber(value) * isDataVoucherDetail[index].gia_von_nt
				);
				updateMyData(
					index,
					'tien_nhap',
					convertStringToNumber(value) * isDataVoucherDetail[index].gia_von_nt * isFieldNt.ty_gia
				);
			},
		},
		{
			Header: `Giá vốn ${isFieldNt?.ma_nt}`,
			accessor: 'gia_von_nt',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			type: 'number',
			Filter: false,
			handleOnChange: (index, value) => {
				updateMyData(index, 'tien_nhap_nt', convertStringToNumber(value) * isDataVoucherDetail[index].sl_nhap);
				updateMyData(
					index,
					'tien_nhap',
					convertStringToNumber(value) * isDataVoucherDetail[index].sl_nhap * isFieldNt.ty_gia
				);
				updateMyData(index, 'gia_von', convertStringToNumber(value) * isFieldNt.ty_gia);
			},
		},
		{
			Header: `Giá vốn VND`,
			accessor: 'gia_von',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
		},
		{
			Header: `Tiền nhập ${isFieldNt?.ma_nt}`,
			accessor: 'tien_nhap_nt',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
		},
		{
			Header: `Tiền nhập VND`,
			accessor: 'tien_nhap',
			width: 150,
			minWidth: 100,
			maxWidth: 400,
			Filter: false,
		},
		{
			Header: 'Vụ việc',
			accessor: 'ma_dt',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			Filter: false,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'ma_dt', item.ma_dt);
				},
				valueField: 'ma_dt',
				labelField: 'ten_dt',
				api: 'dmdt',
				q: { status: true },
				getLabel: (item) => {
					return `${item.ma_dt} - ${item.ten_dt}`;
				},
			},
		},
		{
			Header: 'Hợp đồng',
			accessor: 'ma_hd',
			width: 200,
			minWidth: 150,
			maxWidth: 400,
			Filter: false,
			type: 'select',
			selectObject: {
				onChange: (item, index) => {
					updateMyData(index, 'ma_hd', item.so_hd);
				},
				valueField: 'so_hd',
				labelField: 'ten_hd',
				api: 'contract',
				q: { status: true },
				getLabel: (item) => {
					return `${item.so_hd} - ${item.ten_hd}`;
				},
			},
		},
	];
	const [isDataVoucherDetail, setIsDataVoucherDetail] = useState([]);
	const [dataSelected, setDataSelected] = useState([]);
	const [openDelete, setOpenDelete] = useState(false);

	useEffect(() => {
		if (data === undefined || data?.details.length < 1) {
			const newData = [];
			for (let i = 0; i < 1; i++) {
				newData.push({ ...defaultValues, line: i + 1 });
			}
			setIsDataVoucherDetail(newData);
		} else {
			setIsDataVoucherDetail(data?.details);
		}
	}, []);

	const skipResetRef = React.useRef(false);
	const updateMyData = (rowIndex, columnId, value) => {
		skipResetRef.current = true;
		setIsDataVoucherDetail((old) =>
			old.map((row, index) => {
				if (index === rowIndex) {
					return {
						...row,
						[columnId]: value,
					};
				}
				return row;
			})
		);
	};
	useEffect(() => {
		skipResetRef.current = false;
		handleGetDataDetail && handleGetDataDetail(isDataVoucherDetail);
	}, [isDataVoucherDetail]);

	const menuTabDetail = [
		{
			id: 1,
			tabName: 'Thêm',
			icon: <AiFillFileAdd />,
			handle: () => {
				handleOpenAddDetailItemVoucher();
			},
		},
		// {
		// 	id: 2,
		// 	tabName: 'Chuyển lên',
		// 	icon: <AiOutlineArrowUp />,
		// 	handle: () => {
		// 		// handleMoveRowItemVoucher('up');
		// 	},
		// },
		// {
		// 	id: 3,
		// 	tabName: 'Chuyển xuống',
		// 	icon: <AiOutlineArrowDown />,
		// 	handle: () => {
		// 		// handleMoveRowItemVoucher('down');
		// 	},
		// },
		{
			id: 4,
			tabName: 'Nhân dòng',
			icon: <IoDuplicateOutline />,
			handle: () => {
				handleDuplicateRowItemVoucher();
			},
		},
		{
			id: 5,
			tabName: 'Xoá',
			icon: <AiFillDelete />,
			handle: () => {
				handleDeleteItemVoucher();
			},
		},
		// {
		// 	id: 6,
		// 	tabName: 'Lấy dữ liệu',
		// 	icon: <AiFillCopy />,
		// 	handle: () => {
		// 		console.log(isDataVoucherDetail);
		// 	},
		// },
		{
			id: 7,
			tabName: 'Nhập',
			icon: <BiImport />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
		{
			id: 8,
			tabName: 'Xuất',
			icon: <BiExport />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
		{
			id: 9,
			tabName: 'In',
			icon: <AiFillPrinter />,
			handle: () => {
				alert('Tính năng đang phát triển');
			},
		},
	];

	const handleOpenAddDetailItemVoucher = () => {
		skipResetRef.current = true;
		setIsDataVoucherDetail((old) => [...old, { ...defaultValues, line: old.length }]);
	};

	//On select row
	const onSelectRowClick = (data) => {
		setDataSelected(data);
	};
	const handleDeleteItemVoucher = async () => {
		if (dataSelected.length <= 0) {
			setOpenDelete(true);
		} else {
			if (isDataVoucherDetail && dataSelected) {
				const newData = isDataVoucherDetail.filter((item) => {
					const index = dataSelected.findIndex((selectedItem) => selectedItem.line === item.line);
					return index === -1;
				});

				newData.forEach((item, index) => {
					item.line = index;
				});

				setIsDataVoucherDetail(newData);
				setDataSelected([]);
			}
		}
	};
	const handleCloseDelete = () => {
		setOpenDelete(false);
	};

	const handleMoveRowItemVoucher = async (type) => {
		if (data?.details && dataSelected) {
			// Kiểm tra đang ở vị trí nào trong mảng
			const index = dataSelected[0].line;

			if (type === 'up' && index !== 0) {
				// đổi chỗ với phần tử trước
				const temp = data?.details[index - 1];
				data.details[index - 1] = data?.details[index];
				data.details[index] = temp;
			} else if (type === 'down' && index !== data?.details?.length - 1) {
				// đổi chỗ với phần tử sau
				const temp = data?.details[index + 1];
				data.details[index + 1] = data?.details[index];
				data.details[index] = temp;
			}

			// Cập nhật lại line
			data.details.forEach((item, index) => {
				item.line = index;
			});

			try {
				// await context.apis.asyncPostList(context.userInfo.token, "pt1", {
				// 	...data,
				// });
				// await getDataVoucherPT();
				console.log('dataMove', data);
				setDataSelected([]);
			} catch (error) {
				console.log(error);
			}
		}
	};

	//Nhân dòng
	const handleDuplicateRowItemVoucher = async () => {
		skipResetRef.current = true;
		dataSelected.forEach((item) => {
			delete item._id;
		});
		//  vòng lặp để tạo ra các dòng mới
		const newData = dataSelected.map((item) => {
			return { ...item, line: isDataVoucherDetail.length };
		});

		setIsDataVoucherDetail((old) => [...old, ...newData]);
	};

	return (
		<div className="box_tab_detail_vouvher">
			<div className="box_tab_detail_vouvher__content">
				<TableManager
					idTable={'detail'}
					columns={columns}
					data={view ? data?.details : isDataVoucherDetail || []}
					updateMyData={updateMyData}
					skipReset={skipResetRef.current}
					selectRow={view ? false : true}
					onSelectRowClick={onSelectRowClick}
					readonly={readonly}
					TbodyMaxHeight={'11vh'}
					handleOpenAddDetailItemVoucher={handleOpenAddDetailItemVoucher}
					pagination={false}
					hiddenColumns={isFieldNt?.ma_nt === 'VND' ? ['tien_nhap', 'gia_von'] : []}
					toolBar={
						<>
							{view ? (
								''
							) : (
								<div className="box_tab_detail_vouvher__header">
									{menuTabDetail.map((item) => {
										const shouldDisplayItem =
											dataSelected.length > 0 || (item.id !== 4 && item.id !== 5);
										if (shouldDisplayItem) {
											return (
												<div key={item.id} onClick={item.handle} title={`${item.tabName}`}>
													{item.icon} <span className="tabname_tool_bar">{item.tabName}</span>
												</div>
											);
										}
										return null;
									})}
								</div>
							)}
						</>
					}
				/>
				<NotiDialog
					open={openDelete}
					handleClose={handleCloseDelete}
					title="Thông báo"
					content="Vui lòng chọn ít nhất 1 dòng để thực hiện chức năng này"
				/>
			</div>
		</div>
	);
}

export default TabDetail;
